import { useCurrentTillLocalisation } from "~/api/tills/hooks/use-till-current/localisation";
import { type Country } from "~/api/tills/types";
import {
  DANISH_ALPHABET,
  LATIN_ALPHABET
} from "~/components/collect/operator/collect-name-filter";

// Danish and Norwegian share Æ Ø Å; Swedish uses Å Ä Ö.
const SWEDISH_ALPHABET = [...LATIN_ALPHABET, "Å", "Ä", "Ö"];

const ALPHABET_BY_COUNTRY: Partial<Record<Country, string[]>> = {
  DK: DANISH_ALPHABET,
  NO: DANISH_ALPHABET,
  SE: SWEDISH_ALPHABET
};

/** Name-filter alphabet for the till country; Latin by default. */
export function useAlphabet(): string[] {
  const { country } = useCurrentTillLocalisation();
  return ALPHABET_BY_COUNTRY[country] ?? LATIN_ALPHABET;
}
